export default "__VITE_ASSET__018657c9__"